import { get, post } from '../../utils/myFetch';

export async function getUser(params) {
  return get(`/middlecenter/service/apigateway/api/v1/auth/user/${params}`);
}

export async function checkPass(params) {
  return post(`/middlecenter/service/apigateway/api/v1/auth/user/getPwd`, params);
}

export async function modifyPass(params) {
  return post(`/middlecenter/service/apigateway/api/v1/auth/user/updatePwd`, params);
}
